import React, { useRef, useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
/* import Pagination from 'react-js-pagination'; */
import { useLocation, useNavigate } from 'react-router-dom';
import PDFLoader from './PDFLoader';
import HTMLFlipBook from "react-pageflip";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
/* pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();
 */
export default function PDFViewer() {

    const [scale, setScale] = useState(1.0);
    const location = useLocation();
    const message = location.state.message;
    const [numPages, setNumPages] = useState(null);
    const navigate = useNavigate();
    const goBack = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            alert('No history available to go back.');
        }
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }
   
    const divRef = useRef(null);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const toggleFullscreen = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            divRef.current.requestFullscreen();
        }
    };

    const onChange = () => {
        setIsFullscreen(!!document.fullscreenElement);
    };

    useEffect(() => {
        document.addEventListener('fullscreenchange', onChange);
        return () => {
            document.removeEventListener('fullscreenchange', onChange);
        };
    }, []);

    if (!message) {
        return <div>No PDF file provided.</div>;
    }


    const zoomIn = () => {
        setScale(prevScale => (prevScale < 2.0 ? prevScale + 0.2 : prevScale)); // Max scale of 2.0
    };

    const zoomOut = () => {
        setScale(prevScale => (prevScale > 0.5 ? prevScale - 0.2 : prevScale)); // Min scale of 0.5
    };

    const resetZoom = () => {
        setScale(1.0);
    };
    const flipbookProps = {
        width: 550,
        height: 733,
        size: "stretch",
        minWidth: 315,
        maxWidth: 1000,
        minHeight: 400,
        maxHeight: 1533,
        maxShadowOpacity: 0.5,
        showCover: true,
        mobileScrollSupport: true,
    };


    return (
        <>
            <section ref={divRef} className={`pdf-viewer ${isFullscreen ? 'fullscreen' : ''}`}>
                <div className='container'>
                    <div className='row'>
                        <div className='d-flex justify-content-between align-items-center '>
                            <button className="btn-6 view-all-btnn mb-4 bck_btn " onClick={goBack} tabIndex={-1}><i className="fas fa-long-arrow-alt-left me-2"></i>Back </button>
                            <div className='mb-4'>
                                <button className="btn f_increase view-all-btnn me-2" onClick={zoomIn}><i class="fas fa-search-plus"></i></button>
                                <button className="btn f_increase view-all-btnn me-2" onClick={resetZoom}><i class="fas fa-redo-alt"></i></button>
                                <button className="btn f_increase view-all-btnn me-2" onClick={zoomOut}><i class="fas fa-search-minus"></i></button>
                                <button className="btn-6 view-all-btnn mb-4 bck_btn d-none" onClick={toggleFullscreen}>
                                    {isFullscreen ? 'Exit Fullscreen' : 'Go Fullscreen'}
                                </button>
                            </div>
                        </div>
                        <div className='col-md-12 text-start position-relative pdf-doc mb-5'>
                            <button className="btn-6 view-all-btnn mb-4 bck_btn d-none" onClick={goBack} tabIndex={-1}><i className="fas fa-long-arrow-alt-left me-2"></i>Back </button>
                            <Document file={message} onLoadSuccess={onDocumentLoadSuccess} loading={<PDFLoader />}>
                                <HTMLFlipBook {...flipbookProps}>
                                    {Array.from(new Array(numPages), (el, index) => (
                                        <div className="page" key={`page_${index + 1}`}>
                                            <Page
                                                pageNumber={index + 1}
                                                renderTextLayer={false}
                                                renderAnnotationLayer={false}
                                                scale={scale}
                                            />
                                        </div>
                                    ))}
                                </HTMLFlipBook>
                            </Document>
                        </div>
                    </div>

                </div>

            </section>
        </>

    )
}
